// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'lib-flexible';
import scroll from 'vue-seamless-scroll'
import App from './App'
import router from './router'
Vue.use(scroll)

Vue.config.productionTip = false
Vue.use(ElementUI);
//引入axios
var axios = require('axios')
Vue.config.productionTip = false
import store from './store'
import '../src/components/js/flexible'

axios.defaults.baseURL = 'http://www.yacobon.com/api'

Vue.prototype.$axios = axios
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
      if (store.state.user.username) {
        next()
      } else {
        next({
          path: 'login',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      next()
    }
  }
)
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js